/* eslint-disable */
export default {
  all: 'Todo',
  company: 'Empresa',
  personal: 'Personal',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
